<template>
  <a
    ref="toggleDesc"
    href="javascript:;"
    class="toggle-desc"
    @click.stop="toggleDesc"
  >
    <slot>
      <i
        v-if="show"
        key="arrows"
        class="iconfont icon-arrows_up"
      />
      <i
        v-else
        key="arrows"
        class="iconfont icon-arrows_down"
      />
    </slot>
  </a>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    methods: {
      toggleDesc () {
        this.show = !this.show;
        this.$emit('toggle', this.$refs.toggleDesc);
      }
    }
  }
</script>

<style scoped>
  @import 'variable.css';

  .toggle-desc {
    position: relative;
    display: block;
    height: 22px;
    padding-top: 10px;
    text-align: center;
    outline: none;
    font-size: 16px;
    .icon-arrows_down, .icon-arrows_up {
      margin-left: 4px;
      font-weight: bold;
    }
  }
</style>